import { queryOptions } from "@tanstack/react-query";
import { isNumber } from "lodash-es";
import { DateTime } from "luxon";

import { oneHour } from "@/common/providers/query-provider";
import { getPrediction } from "@/generated/api/prices";

import { CropId } from "./yield-predictions.utils";

type PredictionRate = {
  date: string;
  prediction: number;
  upper: number;
  lower: number;
};

const predictionQuery = (commodity: CropId, zip: string, year: number) =>
  queryOptions({
    queryFn: ({ signal }) =>
      getPrediction(commodity, { year, zip }, { signal }),
    queryKey: ["prediction", commodity, zip, year],
    select: (data) => ({
      commodity: data.commodity,
      rates: data.rates
        .filter(
          (
            r,
          ): r is typeof r & { min: number; max: number; prediction: number } =>
            [r.prediction, r.min, r.max].every(isNumber),
        )
        .map((r) => ({
          date: DateTime.fromISO(r.date).toLocaleString(DateTime.DATE_SHORT),
          lower: r.min,
          prediction: r.prediction,
          upper: r.max,
        })),
    }),
    staleTime: oneHour,
  });

export { predictionQuery };
export type { PredictionRate };
